<button 
    [type]="type" 
    class="btn btn-labeled mr-1 mb-2" 
    [ngClass]="currentClass" 
    [ngStyle]="customStyles"
    [disabled]="disabled || loading" 
    (click)="onClick($event)"
    (mouseenter)="onHover(true)"
    (mouseleave)="onHover(false)">

    <span class="btn-label" *ngIf="preset !== 'refresh'">
        <i *ngIf="!loading" [class]="currentIcon" style="font-size: 1.5em;"></i>
        <i *ngIf="loading" class="fa fa-circle-o-notch fa-spin" style="font-size: 1.5em;"></i>
    </span>

    <span *ngIf="preset !== 'refresh'">{{ label }}</span>
    
    <i *ngIf="!loading && preset === 'refresh'" [class]="currentIcon" style="font-size: 1.5em;"></i>
    <i *ngIf="loading && preset === 'refresh'" class="fa fa-circle-o-notch fa-spin" style="font-size: 1.5em;"></i>
</button>